module.exports = __webpack_public_path__ + "static/media/category16.a39addb7.jpg";